import { createFileRoute } from '@tanstack/react-router'
import { CalendarView } from '@/common/components/calendar-view/CalendarView'
import { Navbar } from '@/common/components/navbar'

export const Route = createFileRoute('/calendar')({
  component: () => (
    <>
      <Navbar />
      <CalendarView />
    </>
  ),
})
